import { Alert, type AlertProps } from '@mui/material';
import { ApiError } from '../api/types/common';

export function ApiErrorAlert({
  error,
  ...alertProps
}: { error: unknown } & Omit<AlertProps, 'severity' | 'children'>) {
  if (!error) return null;
  const message = error instanceof ApiError ? error.message : 'Beklenmeyen bir hata oluştu.';
  return (
    <Alert severity="error" {...alertProps}>
      {message}
    </Alert>
  );
}
